export interface ContractPSCRequest {
  vendorId: string;
  executedDate: string;
  endDate: string;
  comment: string;
}
